<template>
  <div>
    <div class="mb-3" style="font-size: 0.9rem;">
      You can upload data using the following parameterized files.<br />
      Please ensure your file format matches the required parameters for
      successful processing.
    </div>
    <div
      v-for="(infoCompanyFile, i) in infoCompanyFiles"
      :key="i"
      class="container-file-names"
    >
      <strong>{{ infoCompanyFile.auxName }}</strong>
      <template
        v-if="
          infoCompanyFile.auxName === 'Ratios' &&
            infoCompanyFile.file_data.length === 0
        "
      >
        <div class="text-muted no-files">No files available.</div>
      </template>
      <template v-else>
        <div
          v-for="(file, i) in infoCompanyFile.file_data"
          :key="i"
          @change="handleFileName(file.file_name, file, $event)"
          class="container-radio-btn"
        >
          <input
            type="radio"
            :value="file.file_name"
            v-model="formatVars.selectedFile"
            :id="file.file_name"
            name="file"
            class="radio-btn"
          />
          <label :for="file.file_name">{{ processName(file.file_name) }}</label>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyFileManager",
  props: {
    infoCompanyFiles: { required: true, default: () => [] },
    defaultSelectedFile: { required: true, default: "" }
  },
  mounted() {
    this.selectFile(this.defaultSelectedFile);
  },
  data() {
    return {
      data: {},
      formatVars: {
        selectedFile: ""
      }
    };
  },
  watch: {
    infoCompanyFiles: {
      handler(newVal) {
        this.selectFile(newVal[0].fileData[0].sheet_name);
      },
      deep: true
    },
    defaultSelectedFile: {
      handler(newVal) {
        this.selectFile(newVal);
      },
      deep: true
    }
  },
  methods: {
    processName(name) {
      let _this = this;
      // Split the string into an array using "&&" as the delimiter
      let dividedArray = name.split("&&");
      // Use map to process each file name
      let modifiedArray = dividedArray.map(word => _this.subProcessName(word));
      // Join the array back into a single string, with spaces between each element
      return modifiedArray.length > 1
        ? modifiedArray.slice(0, -1).join(", ") +
            " and " +
            modifiedArray[modifiedArray.length - 1]
        : modifiedArray[0];
    },
    subProcessName(name) {
      // Split the string into an array using "_" as the delimiter
      let dividedArray = name.split("_");
      dividedArray =
        dividedArray[0] === "e" || dividedArray[0] === "h"
          ? dividedArray.slice(1)
          : dividedArray;
      // Use map to replace "qs" with "Quanspire"
      let modifiedArray = dividedArray.map(word =>
        word === "Qs" || word === "qs"
          ? "Quanspire"
          : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      );
      // Join the array back into a single string, with spaces between each element
      return modifiedArray.join(" ");
    },
    selectFile(fileName) {
      this.formatVars.selectedFile = fileName;
    },
    /* Events user interactions */
    handleFileName(fileName, file, $event) {
      this.$emit("onFileName", { fileName, file, $event });
    }
  }
};
</script>
